import React, { useState } from "react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Trash2, Plus } from "lucide-react";

const CAT_COLORS = ["#5E8A1E", "#E63946", "#FFC300", "#10B981", "#8B5CF6", "#F97316", "#06B6D4", "#EC4899"];
const empty = { name: "", length: 2, width: 2, consumption: 0, color: "#5E8A1E" };
const numInput =
  "h-8 px-2 border border-[#A8C97D] rounded-none text-sm font-mono-data focus:border-[#5E8A1E] focus:outline-none w-full";
const lbl = "text-[10px] uppercase tracking-wide text-zinc-500";

export default function CategoryManager({ categories, onCreate, onUpdate, onDelete }) {
  const [draft, setDraft] = useState(empty);

  return (
    <div className="space-y-3" data-testid="category-manager">
      <div className="space-y-2">
        {categories.map((c) => (
          <div key={c.id} className="border border-[#C3DBA0] p-2 space-y-2" data-testid={`category-row-${c.id}`}>
            <div className="flex items-center gap-2">
              <input type="color" value={c.color}
                onChange={(e) => onUpdate(c.id, { ...c, color: e.target.value })}
                className="w-6 h-6 border border-[#A8C97D] p-0 cursor-pointer shrink-0"
                data-testid={`category-color-${c.id}`} />
              <input value={c.name}
                onChange={(e) => onUpdate(c.id, { ...c, name: e.target.value })}
                className="flex-1 min-w-0 h-7 px-2 border border-[#A8C97D] rounded-none text-sm focus:border-[#5E8A1E] focus:outline-none"
                data-testid={`category-name-${c.id}`} />
              <button data-testid={`category-delete-${c.id}`} onClick={() => onDelete(c.id)}
                className="text-zinc-400 hover:text-[#E63946] shrink-0">
                <Trash2 size={15} strokeWidth={1.5} />
              </button>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <label className="flex flex-col gap-0.5"><span className={lbl}>Lung m</span>
                <input type="number" step="0.1" value={c.length} className={numInput} data-testid={`category-length-${c.id}`}
                  onChange={(e) => onUpdate(c.id, { ...c, length: parseFloat(e.target.value) || 0 })} /></label>
              <label className="flex flex-col gap-0.5"><span className={lbl}>Lăț m</span>
                <input type="number" step="0.1" value={c.width} className={numInput} data-testid={`category-width-${c.id}`}
                  onChange={(e) => onUpdate(c.id, { ...c, width: parseFloat(e.target.value) || 0 })} /></label>
            </div>
          </div>
        ))}
      </div>

      <div className="border border-dashed border-[#A8C97D] p-2 space-y-2">
        <div className="flex items-center gap-2">
          <input type="color" value={draft.color}
            onChange={(e) => setDraft({ ...draft, color: e.target.value })}
            className="w-7 h-7 border border-[#A8C97D] p-0 cursor-pointer shrink-0" data-testid="new-category-color" />
          <Input data-testid="new-category-name" placeholder="Nume categorie nouă" value={draft.name}
            onChange={(e) => setDraft({ ...draft, name: e.target.value })}
            className="flex-1 min-w-0 h-7 rounded-none border-[#A8C97D] text-sm" />
        </div>
        <div className="grid grid-cols-2 gap-2">
          <label className="flex flex-col gap-0.5"><span className={lbl}>Lung m</span>
            <input type="number" step="0.1" value={draft.length} className={numInput} data-testid="new-category-length"
              onChange={(e) => setDraft({ ...draft, length: parseFloat(e.target.value) || 0 })} /></label>
          <label className="flex flex-col gap-0.5"><span className={lbl}>Lăț m</span>
            <input type="number" step="0.1" value={draft.width} className={numInput} data-testid="new-category-width"
              onChange={(e) => setDraft({ ...draft, width: parseFloat(e.target.value) || 0 })} /></label>
        </div>
        <Button data-testid="add-category-btn"
          onClick={() => { if (draft.name.trim()) { onCreate(draft); setDraft(empty); } }}
          className="w-full h-8 rounded-none bg-[#09090B] hover:bg-[#5E8A1E] text-white text-xs">
          <Plus size={14} className="mr-1" /> Adaugă categorie
        </Button>
      </div>
    </div>
  );
}
